$(document).ready(function () {
    loadChatHistory();

    $(".chat-icon").on("click", function () {
        $(".chat-container").attr("aria-hidden", function (i, val) {
            return val === "true" ? "false" : "true";
        });
    });

    $('#js-chat-send-btn').on('click', function() {
        sendMessage();
    });

    $('#user-input').on('keydown', function(event) {
        if (event.key === "Enter" || event.which === 13) {
            sendMessage();
            event.preventDefault();
        }
    });
});

function loadChatHistory() {
    const token = $('input[name="csrf_token"]').val();
    
    $.ajax({
        type: "POST",
        url: "/ax_chat.php",
        data: {
            csrf_token: token,
            action: 'getHistory'
        },
        dataType: 'json',
        success: function(res) {
            try {
                if (res.history && Array.isArray(res.history)) {
                    res.history.forEach(function(msg) {
                        addMessage(msg.message, msg.sender);
                    });
                }
            } catch(e) {
                console.log('Błąd parsowania historii:', e);
            }
        },
        error: function(err) { 
            console.log('Błąd ładowania historii:', err);
        }
    });
}

function showBotErrorMessage() {
    $('.chat-message.bot.error').show();
    scrollChatToBottom();
}

function sendMessage() {
    const token = $('input[name="csrf_token"]').val();
    const userInput = document.getElementById('user-input').value;
    if (!userInput) return;

    addMessage(userInput, 'user');
    document.getElementById('user-input').value = '';

    $('.chat-message.loader').show();
    scrollChatToBottom();

    $.ajax({
        type: "POST",
        url: "/ax_chat.php",
        dataType: 'json',
        data: {
            csrf_token: token,
            question: userInput,
        },
        success: function(res){
            if (!res.message) {
                showBotErrorMessage();
                return;
            }
            
            typeLoaderMessage(res.message);
        },
        error: function(err){ 
            showBotErrorMessage();
            console.log('Błąd wysyłania wiadomości:', err);
        },
        complete: function(data){
            $('.chat-message.loader').hide();
        }
    });
}

function typeLoaderMessage(message) {
    const newMessage = `
        <div class="chat-message bot text-small-medium">
            <span class="message-text"></span>
        </div>
    `;
    
    const $newMessage = $(newMessage);
    $('.chat-message.loader').before($newMessage);
    scrollChatToBottom();
    
    const messageTextElement = $newMessage.find('.message-text')[0];
    if (!messageTextElement) return;
    
    const chunks = message.match(/\S+\s*/g) || [];
    if (!chunks.length) {
        messageTextElement.innerHTML = parseMarkdown(message);
        scrollChatToBottom();
        return;
    }

    let i = 0;
    
    const interval = setInterval(() => {
        messageTextElement.textContent += chunks[i];
        i++;
        if (i >= chunks.length) {
            clearInterval(interval);
            const parsedMessage = parseMarkdown(message);
            messageTextElement.innerHTML = parsedMessage;
            scrollChatToBottom();
        }
    }, 40);
}

function parseMarkdown(text) {
    // Code blocks (multiline)
    text = text.replace(/```([^]+?)```/g, '<pre>$1</pre>');
    // Inline code
    text = text.replace(/`([^`]+?)`/g, '<code>$1</code>');
    // Bold
    text = text.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    // Italic
    text = text.replace(/\*([^*]+)\*/g, '<em>$1</em>');
    // Strikethrough
    text = text.replace(/~~(.+?)~~/g, '<del>$1</del>');
    // Links
    text = text.replace(/\[([^\]]+)]\((http[s]?:\/\/[^\)]+)\)/g, '<a href="$2">$1</a>');
    // Headers
    text = text.replace(/^###### (.*$)/gm, '<h6>$1</h6>');
    text = text.replace(/^##### (.*$)/gm, '<h5>$1</h5>');
    text = text.replace(/^#### (.*$)/gm, '<h4>$1</h4>');
    text = text.replace(/^### (.*$)/gm, '<h3>$1</h3>');
    text = text.replace(/^## (.*$)/gm, '<h2>$1</h2>');
    text = text.replace(/^# (.*$)/gm, '<h1>$1</h1>');
    // List items (numbered)
    text = text.replace(/^\s*\d+\.\s+(.*$)/gm, '<li>$1</li>');
    // Wrap list items with <ol> tags (simple transformation)
    text = text.replace(/((<li>.*<\/li>\s?)+)/gm, '<ol>$1</ol>');
    // New lines to <br>
    text = text.replace(/\n/g, '<br>');
    return text;
}

function addMessage(message, sender) {
    if(sender == 'user'){
        var cssClass = 'user';
        var role = 'Gość';
    }
    else{
        var cssClass = 'bot';
        var role = 'Chat bot';
    }

    const parsedMessage = parseMarkdown(message);

    const newMessage = `
        <div class="chat-message ${cssClass} text-small-medium">
            ${parsedMessage}
        </div>
    `;

    $('.chat-message.loader').before(newMessage);
    scrollChatToBottom();
}

function scrollChatToBottom() {
    const chatBox = document.getElementById('chat-box');
    chatBox.scrollTop = chatBox.scrollHeight;
}